/**
 * RESPONSIBILITY: fetch the channel's latest sermons, shared by every band that shows one.
 *
 * A plain query, not `cms.get()` — this is YouTube's data, not a section, so it has no
 * version and nothing for the CMS's batching loader to do. TanStack Query still shares
 * one cache entry across the home page and the sermons page, so two bands asking for the
 * same six videos cost one request, not two.
 */
import { useQuery } from '@tanstack/react-query';
import { APP_ROUTES } from '../../app-routes';

export interface LiveSermon {
  videoId: string;
  title: string;
  url: string;
}

const LIMIT = 6;

export function useLatestSermons(): LiveSermon[] {
  const { data } = useQuery({
    queryKey: ['youtube-sermons', LIMIT],
    queryFn: async (): Promise<LiveSermon[]> => {
      const res = await fetch(`${APP_ROUTES.youtubeSermons}?limit=${LIMIT}`);
      if (!res.ok) throw new Error(`sermons feed request failed: ${res.status}`);
      const body = await res.json() as { sermons: LiveSermon[] };
      return body.sermons;
    },
    staleTime: 10 * 60 * 1000,
  });
  return data ?? [];
}
